import { takeEvery } from 'redux-saga/effects';
import { apiRequestSuccess } from 'services/api/api.actions';
import { getUserProfileEndpoint } from 'services/user/user.config';
import { UserDataPayload } from 'services/user/user.types';

function* handleUserInfoForVivocha(
  action: ReturnType<typeof apiRequestSuccess>,
) {
  if (action.payload.resourceId !== getUserProfileEndpoint) {
    return;
  }

  const data: UserDataPayload = action.payload.response.data;

  // Requested by Vivocha to use the value of codiceConto from sessionStorage to
  // enable chat functionality from the provider's script.
  window.sessionStorage.setItem('codiceConto', data.personalData.billCode);

  // Requested by Vivocha to use the value of vivochaJwt from window to enable
  // chat functionality from the provider's script.
  window.vivochaJwt = data.vivochaJwt;
}

export default function* vivochaSaga() {
  yield takeEvery(apiRequestSuccess.type, handleUserInfoForVivocha);
}
